import { Box, IconButton, Typography } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { RoundedButton } from "../../../common/components/styled/styled";
import { ReactComponent as ArrowLeftIcon } from "../../../common/icons/arrowLeftLarge.svg";
import { ReactComponent as AttachmentIcon } from "../../../common/icons/attachment.svg";
import { ReactComponent as EditPinIcon } from "../../../common/icons/editPin.svg";
import { ReactComponent as LanguageIcon } from "../../../common/icons/language.svg";
import { ReactComponent as UserCheckedIcon } from "../../../common/icons/userChecked.svg";
import { AccessRightContext } from "../../user/AccessRightProvider";
import { JobAdStatus } from "../types/common";
import { JobAdTitle, JobAdTitleContainer } from "../styles";

type Props = {
  title: string;
  isEditing: boolean;
  jobAdStatus: JobAdStatus | undefined;
  handleCloseJobAd: () => void;
  handleDeleteDraft: () => void;
  handleReOpenJobAd: () => void;
  handleBackClick: () => void;
  hideInfo?: boolean;
};

export const JobAdHeader = ({
  title,
  isEditing,
  jobAdStatus = JobAdStatus.DRAFT,
  handleCloseJobAd,
  handleDeleteDraft,
  handleReOpenJobAd,
  handleBackClick,
  hideInfo,
}: Props) => {
  const { t } = useTranslation();
  const { canWriteJobAd } = useContext(AccessRightContext);

  return (
    <>
      <Box display="flex" flexDirection="row" alignItems="center">
        <JobAdTitleContainer>
          <IconButton onClick={handleBackClick}>
            <ArrowLeftIcon />
          </IconButton>
          <JobAdTitle variant="header">{title}</JobAdTitle>
        </JobAdTitleContainer>

        {!isEditing && (
          <Box sx={{ margin: "0 42px 0 auto" }} display="flex" columnGap="32px">
            <Box display="flex" alignItems="center" columnGap="8px">
              {jobAdStatus === JobAdStatus.DRAFT ? (
                <AttachmentIcon />
              ) : jobAdStatus === JobAdStatus.CLOSED ? (
                <UserCheckedIcon />
              ) : (
                <LanguageIcon />
              )}
              <Typography>{t(`jobAds:${jobAdStatus}`)}</Typography>
            </Box>
            {canWriteJobAd && jobAdStatus === JobAdStatus.DRAFT && (
              <RoundedButton
                variant="contained"
                color={"error"}
                onClick={handleDeleteDraft}
              >
                {t("jobAds:deleteDraft")}
              </RoundedButton>
            )}
            {canWriteJobAd &&
              (jobAdStatus === JobAdStatus.PUBLISHED ||
                jobAdStatus === JobAdStatus.EXPIRED) && (
                <RoundedButton
                  variant="contained"
                  color={"error"}
                  onClick={handleCloseJobAd}
                >
                  {t("jobAds:closeJobAd")}
                </RoundedButton>
              )}
            {canWriteJobAd && jobAdStatus === JobAdStatus.CLOSED && (
              <RoundedButton
                variant="contained"
                color={"primary"}
                onClick={handleReOpenJobAd}
              >
                {t("jobAds:reOpenJobAd")}
              </RoundedButton>
            )}
          </Box>
        )}
      </Box>
      {!hideInfo && (
        <Box margin="16px 0 16px 20px" display="flex" alignItems="center">
          <EditPinIcon />
          <Typography marginLeft="16px">
            {t("jobAds:newJobAdInfo")}
            <Link to="/home/orders">{t("jobAds:newJobAdInfoLink")}</Link>.
          </Typography>
        </Box>
      )}
    </>
  );
};

export default JobAdHeader;
